import { ReadOutlined, MediumOutlined } from '@ant-design/icons';
import { Button, Card, Col, Row, Typography } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';


const { Title } = Typography;

const BlogList = ({ blog }) => {

    const { title, date, image } = blog

    return (
        <>
            <Row justify="center" style={{ margin: ' 2rem 0' }}>
                <Col xs={24} sm={24} md={20} lg={18} xl={16} xxl={14} >
                    <Card title={date}>
                        <Row>
                            <Col xs={24} sm={20} md={18} lg={18} xl={16} xxl={20} >
                                <Link to="#"> <Title level={4}> {title} </Title> </Link>
                            </Col>

                            <Col xs={24} sm={4} md={6} lg={6} xl={8} xxl={4} >
                                <img src={image} alt={title} width="100%" />
                            </Col>
                        </Row>
                        <Button type="primary" ghost size="large" > <ReadOutlined /> Read More </Button>
                        <Button type="primary" ghost size="large" style={{ float: 'right' }} > <MediumOutlined /> Read Medium </Button>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default BlogList;